import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import timeIcons from "../../../../../assets/timeIcons.svg";
import laguageIcon from "../../../../../assets/laguageIcon.svg";
import laguageIconWhite from "../../../../../assets/WhiteIcons/laguageIcon_white.svg";

import counrtyIcon from "../../../../../assets/counrtyIcon.svg";
import counrtyIconWhite from "../../../../../assets/WhiteIcons/counrtyIcon_white.svg";

import sorts from "../../../../../assets/sorts.svg";
import sortsWhite from "../../../../../assets/WhiteIcons/sorts_white.svg";

import defaultImg from "../../../../../assets/WidgetMaker/Brocken_Image.svg";

import Default_Brand from "../../../../../assets/brandLogos/Default_Brand.svg";
import {
  Menu,
  Dropdown,
  Tooltip,
  Pagination,
  Radio,
  Image,
  Popover,
} from "antd";
import {
  clearPaginatedData,
  FilterPillsDeepDiveResponse,
} from "../../../../../redux/actions/dashboard/Tab1";
import {
  setDeepDiveNewsObject,
  setDeepDiveObject,
} from "../../../../../redux/actions/WidgetMaker/WidgetMaker";
import CarouselWidgetMaker from "../../../../WidgetMaker/Carousel";

import {
  setMentionPageInnerTabs,
  setMentionTabsNews,
} from "../../../../../redux/actions/DeepDive";
import {
  getPaneIndex,
  getTextDirection,
  getTextWithWrapHtml,
  getWindowLocationPath,
  useQuery,
} from "../../../../../redux/constants";
import { SocialMedialogo } from "../../DeepDivetab/SocialMediaPlatforms";
import ReadMore from "../../../../layout/WelcomePage/Worksheets/ReadMore";
import { getDeepDive } from "../../../../../redux/actions/WidgetMaker/WidgetAPI";
import { getDynamicChannelIcon } from "../../../../../redux/constants/ChannelIcons";
import { getDynamicIconColor } from "../../../../../redux/constants/DynamicIconColor";
import PaginationComponent from "../../../../WidgetMaker/PaginationComponent";
import SortBy from "../../../../WidgetMaker/SortBy";
import { MentionIdComponent } from "../../../../WidgetMaker/MentionIdComponent";
import { sentimentClass } from "../../../../../redux/constants/enums";

const NewsCard = ({
  newsDatas,
  highlightWord,
  pagination,
  filterPills,
  totalPageNo,
  metadata,
  section_index,
  widget_index,
  mentionPage,
  deepDive,
  isPreviewState,
  dashboard,
  PdfDownloadStatus,
  PptGeneratingStatus,
  widget_id,
  noteExist,
  chart_type,
  isCommandCenterScreen,
  isTwitterTrendScreen,
}) => {
  const dispatch = useDispatch();
  let query = useQuery();
  const tabLoader = useSelector((state) => state.DeepDive.tabLoader);
  const panes = useSelector((state) => state?.Tab1?.panes); //all tabs data
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  let index = getPaneIndex(panes, activeKey);
  const authParams = useSelector((state) => state?.Authentication?.authParams);
  const deepdive_object = useSelector(
    (state) => state?.WidgetMaker?.deepdive_object
  );
  const deepdive_news_object = useSelector(
    (state) => state?.WidgetMaker?.deepdive_news_object
  );
  const shareBrands = useSelector((state) => state.ApiCall.shareBrands);
  const shareableLinkDeepDiveStatus = useSelector(
    (state) => state?.ApiCall?.shareableLinkDeepDiveStatus
  );
  const screen = useSelector((state) => state?.Screens?.screen);
  const deepdiveDashboardTemplateData = useSelector(
    (state) => state?.DeepDiveDashboard?.dashboardTemplateData
  );
  const [sorting, setsorting] = useState({
    value: "Engagement",
    sortOrder: "High - Low",
  });
  const [mentionPageData, setMentionPageDatas] = useState(null);
  const [selectSortBy, setSelectSortBy] = useState({
    sortBy:
      deepdive_news_object?.order_by?.attribute === "engagement"
        ? "RecordDate"
        : deepdive_news_object?.order_by?.attribute
        ? deepdive_news_object?.order_by?.attribute
        : "RecordDate",
    orderBy: deepdive_news_object?.order_by?.sort_order
      ? deepdive_news_object?.order_by?.sort_order
      : "desc",
  });
  const isDeepDiveDashboardView = useMemo(() => {
    let pathName = getWindowLocationPath()?.toLowerCase();
    return (
      (authParams?.screen_id
        ? screen?.isDeepDiveDashboard
          ? true
          : false
        : shareableLinkDeepDiveStatus
        ? shareTemplateData?.isDeepDiveDashboard
          ? true
          : false
        : !authParams?.screen_id &&
          !shareBrands &&
          (pathName === "dashboard" || pathName === "pin-dashboard") &&
          !panes?.[getPaneIndex(panes, activeKey)]?.is_widget_maker_open_obj
            ?.open_flag &&
          panes?.[getPaneIndex(panes, activeKey)]?.isDeepDiveDashboard
        ? true
        : false) && !deepdiveDashboardTemplateData?.isDeepDive
    );
  }, [
    screen,
    shareTemplateData,
    panes,
    authParams,
    deepdiveDashboardTemplateData,
  ]);
  const randomColor = () => {
    var letters = "0123456789ABCDEF";
    var color = "#";
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  let currentPage =
    deepdive_news_object?.order_by?.widget_ids === "1.2"
      ? deepdive_news_object?.order_by?.offset / 10
      : 0;
  let totalPageLength = newsDatas?.no_of_pages * 10;

  let initPage =
    deepdive_news_object?.order_by?.widget_ids === "1.2" &&
    deepdive_news_object?.order_by?.offset
      ? deepdive_news_object?.order_by?.offset + 1
      : 0 + 1;
  let startPage = initPage;

  let page = currentPage + 1;
  let showTotalPages = page * 10;

  const handleChangePaginationNews = (page) => {
    let newPage = page - 1;
    let pageNo = newPage * 10;

    let widget_ids = ["1.2"];
    let arrr = {
      ...deepdive_object,
      tabName: "Mentions",
      deepdive_on: {
        ...deepdive_object.deepdive_on,
        order_by: {
          attribute: deepdive_object?.deepdive_on?.order_by?.attribute
            ? deepdive_object?.deepdive_on?.order_by?.attribute === "engagement"
              ? "RecordDate"
              : deepdive_object?.deepdive_on?.order_by?.attribute
            : "RecordDate",
          offset: pageNo,

          sort_order: deepdive_object?.deepdive_on?.order_by?.sort_order
            ? deepdive_object?.deepdive_on?.order_by?.sort_order
            : "desc",
          widget_ids: widget_ids[0],
        },
      },
      shareTemplateData: shareTemplateData,
      shareBrands: shareBrands,
    };
    dispatch(setDeepDiveObject(arrr));
    let news_object = {
      order_by: {
        attribute: deepdive_object?.deepdive_on?.order_by?.attribute
          ? deepdive_object?.deepdive_on?.order_by?.attribute === "engagement"
            ? "RecordDate"
            : deepdive_object?.deepdive_on?.order_by?.attribute
          : "RecordDate",
        offset: pageNo,
        sort_order: deepdive_object?.deepdive_on?.order_by?.sort_order
          ? deepdive_object?.deepdive_on?.order_by?.sort_order
          : "desc",
        widget_ids: widget_ids[0],
      },
    };
    dispatch(setDeepDiveNewsObject(news_object));
    // dispatch(setDeepDiveInfoLoader(true));

    let commandCenterPath = getWindowLocationPath()?.toLowerCase();
    if (commandCenterPath !== "CommandCenter"?.toLowerCase()) {
      !shareTemplateData &&
        dispatch(clearPaginatedData(panes, index, "news_mentions"));
    }
    shareTemplateData &&
      dispatch({
        type: "SET_SHARE_TEMPLATE_DATA",
        payload: {
          ...shareTemplateData,
          deep_dive: {
            ...shareTemplateData?.deep_dive,
            news_mentions: {
              ...shareTemplateData?.deep_dive?.news_mentions,
              result: {
                ...shareTemplateData?.deep_dive?.news_mentions?.result,
                data: null,
              },
            },
          },
        },
      });

    if (commandCenterPath === "CommandCenter"?.toLowerCase()) {
      arrr.screen = screen;
      // console.log("updated arrr", arrr);
      dispatch(getDeepDive(authParams, arrr, widget_ids));
    } else {
      dispatch(
        FilterPillsDeepDiveResponse(
          panes,
          index,
          authParams,
          arrr,
          widget_ids,
          query?.get("share_id")
        )
      );
    }
  };

  const onSortChange = (e) => {
    dispatch(setMentionTabsNews(true));
    dispatch(setMentionPageInnerTabs(false));
    let widget_ids = ["1.2"];
    let arrr = {
      ...deepdive_object,
      tabName: "Mentions",
      deepdive_on: {
        ...deepdive_object.deepdive_on,
        order_by: {
          attribute: e?.sortBy
            ? e?.sortBy
            : deepdive_object?.deepdive_on?.order_by?.attribute,
          sort_order: e?.orderBy
            ? e?.orderBy
            : deepdive_object?.deepdive_on?.order_by?.sort_order,
          offset: 0,
          widget_ids: widget_ids[0],
        },
      },
    };
    dispatch(setDeepDiveObject(arrr));
    let news_object = {
      order_by: {
        attribute: e?.sortBy
          ? e?.sortBy
          : deepdive_news_object?.order_by?.attribute,
        sort_order: e?.orderBy
          ? e?.orderBy
          : deepdive_news_object?.order_by?.sort_order,
        offset: 0,
        widget_ids: widget_ids[0],
      },
    };
    dispatch(setDeepDiveNewsObject(news_object));
    let index = getPaneIndex(panes, activeKey);

    let commandCenterPath = window?.location?.pathname?.split("/")?.[1];
    if (commandCenterPath === "CommandCenter"?.toLowerCase()) {
      arrr.screen = screen;
      // console.log("updated arrr", arrr);
      dispatch(getDeepDive(authParams, arrr, widget_ids));
    } else {
      dispatch(
        FilterPillsDeepDiveResponse(
          panes,
          index,
          authParams,
          arrr,
          widget_ids,
          query?.get("share_id")
        )
      );
    }

    if (commandCenterPath !== "CommandCenter"?.toLowerCase()) {
      !shareTemplateData &&
        dispatch(clearPaginatedData(panes, index, "news_mentions"));
    }
    shareTemplateData &&
      dispatch({
        type: "SET_SHARE_TEMPLATE_DATA",
        payload: {
          ...shareTemplateData,
          deep_dive: {
            ...shareTemplateData?.deep_dive,
            news_mentions: {
              ...shareTemplateData?.deep_dive?.news_mentions,
              result: {
                ...shareTemplateData?.deep_dive?.news_mentions?.result,
                data: null,
              },
            },
          },
        },
      });
  };
  const menuItem = (
    <Menu className="text_regular">
      <Menu.ItemGroup className="ItemGroup" title="Sort By">
        <Radio.Group
          className="d-flex flex-column p-1"
          onChange={(e) =>
            onSortChange({
              sortBy: e.target.value,
              orderBy: deepdive_news_object?.order_by?.sort_order
                ? deepdive_news_object?.order_by?.sort_order
                : "desc",
            })
          }
          value={selectSortBy?.sortBy}
        >
          <Radio className="text_regular mb-1" value="NumLikesCount">
            Number of Likes
          </Radio>
          <Radio className="text_regular mb-1" value="NumCommentsCount">
            Number of Comments
          </Radio>
          <Radio className="text_regular mb-1" value="NumShareCount">
            Number of Shares
          </Radio>
          <Radio className="text_regular mb-1" value="RecordDate">
            Posted Date
          </Radio>
        </Radio.Group>
      </Menu.ItemGroup>
      <Menu.Divider />
      <Menu.ItemGroup className="ItemGroup" title="Order By">
        <Radio.Group
          className="d-flex flex-column p-1"
          onChange={(e) =>
            onSortChange({
              sortBy: selectSortBy?.sortBy,
              orderBy: e.target.value,
            })
          }
          value={selectSortBy.orderBy}
        >
          <Radio className="text_regular mb-1" value="asc">
            Ascending
          </Radio>
          <Radio className="text_regular mb-1" value="desc">
            Descending
          </Radio>
        </Radio.Group>
      </Menu.ItemGroup>
    </Menu>
  );
  let currentPath = window.location.pathname;
  let splitPath = currentPath.split("/");

  return (
    <>
      {/* {totalPageLength > 10 ? (
        <>
        <div className="mb-15 row">
          <div
            style={{ display: `${splitPath === "widgetMaker" ? "none" : ""}` }}
            className={`mantion__Filter-count col-12 col-md-4  align-items-center justify-content-sm-center justify-content-md-start  `}
          >
            {`Showing ${startPage} - ${
              showTotalPages > newsDatas?.no_of_cards
                ? newsDatas?.no_of_cards
                : showTotalPages
            } News`}
          </div>
        </div>
        </>
      ) : (
        <>
           <div className="d-flex flex-row-reverse mb-1 mt-1">
          <Dropdown
            menu={menuItem}
            placement="bottomRight"
            //trigger={["click"]}
            overlayClassName={
              authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
            }
          >
            <div className="ant-dropdown-link cursor-pointer">
              <img
                src={authParams?.theme_type === "1" ? sortsWhite : sorts}
                alt="sorts"
              />
            </div>
          </Dropdown>
        </div> 
        </>
      )} */}
      {deepDive ||
      splitPath[1] === "widgetMaker" ||
      splitPath[1] === "edit-widget" ? (
        <div
          id={`post_card_${section_index ? section_index : "section_index"}_${
            widget_index ? widget_index : "widget_index"
          }`}
          className={`w-100 wm-chart-cards text-right`}
        >
          <SortBy
            filterPills={filterPills}
            metadata={metadata}
            section_index={section_index}
            widget_index={widget_index}
            isPreviewState={isPreviewState}
            PdfDownloadStatus={PdfDownloadStatus}
            PptGeneratingStatus={PptGeneratingStatus}
            widget_id={widget_id}
            chart_type={chart_type}
            dashboard={dashboard}
            deepDive={deepDive}
          />
        </div>
      ) : (
        ""
      )}
      {tabLoader || !newsDatas?.data ? (
        <div className="loader" style={{ height: "calc(100vh - 17.2rem)" }}>
          <div className="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      ) : (
        newsDatas?.data &&
        newsDatas?.data.map((el, i) => {
          if (PptGeneratingStatus && i > 1) {
            return null;
          } else if (PdfDownloadStatus && i > 1) {
            return null;
          }
          let descriptionDirection = getTextDirection(el?.Description || "");
          return (
            <div
              key={`${el?.ParentSocialID}_item${i}`}
              className={`postcard-class-for-mention card border-color mb-15 text-left ml-15 mr-15 ${
                deepDive ? "mt-0" : "mt-15"
              } ${sentimentClass[el.SentimentType] || "default-text-color"}`}
            >
              <MentionIdComponent
                color={el?.SentimentType || "default-text-color"}
                id={el?.mention_id}
                top={"-26px"}
                type="news-card"
              />
              <div
                className={`cardList-head border-bottom border-color p-15 ${
                  el?.SentimentType ? "pl-0" : ""
                } mb-15 card-head text_heading d-flex align-items-top justify-content-between`}
              >
                <div className="d-flex align-items-center newsCard__header">
                  {el?.SentimentType && !isTwitterTrendScreen ? (
                    <div
                      style={{
                        borderLeft: `0.4rem solid ${
                          el?.SentimentType === "Positive"
                            ? "#5ED142"
                            : el?.SentimentType === "Negative"
                            ? "#FF5D48"
                            : el?.SentimentType === "Neutral"
                            ? "#F0C52F"
                            : "black"
                        }`,
                        height: "3.6rem",
                        marginRight: "1rem",
                      }}
                      // className={`${qrChannel ? "d-none" : ""}`}
                    ></div>
                  ) : (
                    ""
                  )}
                  {el?.AuthorName && (
                    <span className="text_regular mr-2">
                      <span
                        className="font-size12 mr-1"
                        style={{
                          backgroundColor: randomColor(),
                          color: "#fff",
                          padding: "0.1rem 0.5rem",
                          borderRadius: "50%",
                        }}
                      >
                        {el?.AuthorName[0]}
                      </span>
                      {el?.AuthorName}{" "}
                    </span>
                  )}
                  <span className="text_regular mr-2 d-inline-flex align-items-center newsCard__header--wrap">
                    <Image
                      src={el?.brand_url}
                      style={{ maxWidth: "1.8rem", minHeight: "1.8rem" }}
                      alt="defaultImg"
                      fallback={Default_Brand}
                      preview={false}
                      className="border"
                    />
                    {el?.BrandFriendlyName}{" "}
                  </span>
                  <span className="text_regular mr-2 d-inline-flex align-items-center newsCard__header--wrap">
                    <img
                      src={
                        authParams?.theme_type === "1"
                          ? counrtyIconWhite
                          : counrtyIcon
                      }
                      style={{ maxWidth: "1.8rem", minHeight: "1.8rem" }}
                      alt="counrty Icon"
                      className="border"
                    />
                    {el?.CountryName}{" "}
                  </span>
                  {el?.DomainName && (
                    <span className="text_regular mr-2 d-inline-flex align-items-center newsCard__header--wrap">
                      <Image
                        src={el?.favicon === "NA" ? Default_Brand : el?.favicon}
                        style={{ maxWidth: "1.8rem", minHeight: "1.8rem" }}
                        alt="favicon"
                        fallback={Default_Brand}
                        preview={false}
                        className="border"
                      />{" "}
                      {el?.DomainName}
                    </span>
                  )}
                  {el?.lang && (
                    <span className="text_regular d-inline-flex align-items-center newsCard__header--wrap">
                      <img
                        src={
                          authParams?.theme_type === "1"
                            ? laguageIconWhite
                            : laguageIcon
                        }
                        style={{ maxWidth: "1.8rem" }}
                        alt={laguageIcon}
                      />{" "}
                      {el?.lang}
                    </span>
                  )}
                </div>
                {el?.RecordDate && (
                  <div className="text_regular d-inline-flex align-items-center newsCard__header date-icons-header ">
                    <span className="font-weight500">
                      {/* <img
                        src={timeIcons}
                        style={{ maxWidth: "1.8rem" }}
                        alt={timeIcons}
                      />{" "} */}
                      <span style={{ maxWidth: "1.8rem" }}>
                        {" "}
                        {getDynamicIconColor("clock_icon")}
                      </span>
                      Published On:{" "}
                    </span>
                    <span className="text_regular-gray">{el?.RecordDate}</span>
                  </div>
                )}
              </div>
              <div className="d-flex pl-15 pr-15 pb-15 w-100">
                <div className="w-100">
                  <div
                    className={`mb-15 font-weight600 newsCard__textColor ${
                      descriptionDirection === "rtl" ? "text-right-arabic" : ""
                    }`}
                  >
                    {getTextWithWrapHtml(el?.Title, "", highlightWord)}
                  </div>
                  <div
                    className={`w-100 newsCard__textColor ${
                      descriptionDirection === "rtl" ? "text-right-arabic" : ""
                    }`}
                  >
                    <span
                      className={
                        el?.PostURL && el?.PostURL !== 0
                          ? ""
                          : "pointer-events1 cursor-default"
                      }
                      // href={el?.PostURL && el?.PostURL !== 0 ? el?.PostURL : ""}
                      // target="_blank"
                      // rel="noreferrer"
                      // onClick={(e) => e.preventDefault()}
                    >
                      {/* <ReadMore
                        //hendleClick={hendleClick}
                        lengthslice="1200"
                        length={el?.Description?.length}
                      >
                        {el?.Description}
                      </ReadMore> */}
                      <div className="text_regular">
                        <span>
                          {getTextWithWrapHtml(
                            PptGeneratingStatus
                              ? el?.Description?.slice(0, 1200)
                              : PdfDownloadStatus
                              ? el?.Description?.slice(0, 500)
                              : el?.Description?.slice(0, 700),
                            "",
                            highlightWord,
                            descriptionDirection
                          )}
                        </span>
                        {(
                          PptGeneratingStatus
                            ? el?.Description?.length > 1200
                            : PdfDownloadStatus
                            ? el?.Description?.length > 500
                            : el?.Description?.length > 700
                        ) ? (
                          <span className="text-blue cursor-default">
                            {"..."}
                          </span>
                        ) : (
                          ""
                        )}
                        <a
                          className="d-flex gap-10 mt-1"
                          href={
                            el?.PostURL && el?.PostURL !== 0 ? el?.PostURL : ""
                          }
                          target="_blank"
                          rel="noreferrer"
                          style={{ width: "fit-content" }}
                        >
                          <Tooltip
                            title={
                              el?.PostURL &&
                              el?.PostURL?.trim() &&
                              el?.PostURL !== "NA" &&
                              el?.Description?.length > 700
                                ? "Read Full Article"
                                : el?.Description?.length &&
                                  el?.Description?.length < 700
                                ? "Open Article"
                                : "News URL is not available"
                            }
                            className="d-flex gap-10"
                          >
                            <span
                              className={`blue-text font-size14 cursor-pointer`}
                              // href={
                              //   el?.PostURL && el?.PostURL !== 0
                              //     ? el?.PostURL
                              //     : ""
                              // }
                              // target="_blank"
                              // rel="noreferrer"
                            >
                              <i class={`fas fa-external-link-alt`} />
                            </span>
                            {!PdfDownloadStatus &&
                            !PptGeneratingStatus &&
                            el?.Description?.length > 700 ? (
                              <span>
                                <span
                                  className="text-blue"
                                  // onClick={() => handleToggle(i)}
                                >
                                  {"Read Full Article"}
                                </span>
                              </span>
                            ) : (
                              ""
                            )}
                          </Tooltip>
                        </a>
                      </div>
                    </span>
                  </div>
                </div>

                {el?.Attachment?.length === 1 ? (
                  <div
                    style={{ height: "20rem", maxWidth: "20rem" }}
                    className="m-0 w-100 text-center"
                  >
                    {el?.Attachment &&
                      el?.Attachment.map((imgUrl, i) => {
                        return (
                          imgUrl && (
                            <Image
                              src={imgUrl}
                              alt="Attachment Images"
                              fallback={defaultImg}
                              className="w-100"
                              style={{ height: "20rem" }}
                            />
                          )
                        );
                      })}
                  </div>
                ) : (
                  el?.Attachment?.length > 1 && (
                    <div style={{ width: "20rem" }}>
                      <CarouselWidgetMaker
                        imageUrl={el?.Attachment && el?.Attachment}
                        isDeepDiveDashboardView={isDeepDiveDashboardView}
                      />
                    </div>
                  )
                )}
              </div>
              <div className="d-flex flex-wrap border-top border-color pt-15 ml-15 mb-15">
                <div
                  className="newsCard__statsCard border-radius-4 p-15 box-shadow mr-15"
                  style={{
                    minWidth: "20rem",
                  }}
                >
                  <div className="text_regular font-weight500 mb-1 line-height-normal">
                    Comments
                  </div>
                  <div className="d-flex channel_wise justify-content-between align-items-center">
                    <div className="font-weight500 font-size18 newsCard__textColor">
                      {el?.CommentsCount?.Total}
                    </div>
                    <Popover
                      overlayClassName={
                        authParams?.theme_type === "1"
                          ? "darkTheme"
                          : "lightTheme"
                      }
                      content={
                        el?.CommentsCount?.channel_wise && (
                          <div className="p-15">
                            {el?.CommentsCount?.channel_wise.map((el, i) => {
                              return (
                                <div className="d-flex align-items-center mb-1">
                                  <Tooltip title={el?.channel}>
                                    <span className="text_regular mr-1 line-height-normal">
                                      <img
                                        src={
                                          SocialMedialogo?.[el?.channel]
                                            ? SocialMedialogo?.[el?.channel]
                                            : Default_Brand
                                        }
                                        alt={el?.channel}
                                        style={{ width: "2rem" }}
                                        className="channelIcon mr-1"
                                      />
                                    </span>
                                    <span className="text_regular font-weight500">
                                      {el?.count}
                                    </span>
                                  </Tooltip>
                                </div>
                              );
                            })}
                          </div>
                        )
                      }
                      title={null}
                      trigger="click"
                    >
                      {el?.CommentsCount?.channel_wise && (
                        <i className="fa fa-angle-down cursor-pointer" />
                      )}
                    </Popover>
                  </div>
                </div>

                <div
                  className="newsCard__statsCard border-radius-4 p-15 box-shadow mr-15"
                  style={{
                    minWidth: "20rem",
                  }}
                >
                  <div className="text_regular font-weight500 mb-1 line-height-normal">
                    Shares
                  </div>
                  <div className="d-flex channel_wise justify-content-between align-items-center">
                    <div className="font-weight500 font-size18 newsCard__textColor">
                      {el?.SharesCount?.Total}
                    </div>
                    <Popover
                      overlayClassName={
                        authParams?.theme_type === "1"
                          ? "darkTheme"
                          : "lightTheme"
                      }
                      content={
                        el?.SharesCount?.channel_wise && (
                          <div className="p-15">
                            {el?.SharesCount?.channel_wise.map((el, i) => {
                              return (
                                <div className="d-flex align-items-center mb-1">
                                  <Tooltip title={el?.channel}>
                                    <span className="text_regular mr-1 line-height-normal">
                                      <img
                                        src={
                                          SocialMedialogo?.[el?.channel]
                                            ? SocialMedialogo?.[el?.channel]
                                            : Default_Brand
                                        }
                                        alt={el?.channel}
                                        style={{ width: "2rem" }}
                                        className="channelIcon mr-1"
                                      />
                                    </span>
                                    <span className="text_regular font-weight500">
                                      {el?.count}
                                    </span>
                                  </Tooltip>
                                </div>
                              );
                            })}
                          </div>
                        )
                      }
                      title={null}
                      trigger="click"
                    >
                      {el?.SharesCount?.channel_wise && (
                        <i className="fa fa-angle-down cursor-pointer" />
                      )}
                    </Popover>
                  </div>
                </div>

                <div
                  className="newsCard__statsCard border-radius-4 p-15 box-shadow mr-15"
                  style={{
                    minWidth: "20rem",
                  }}
                >
                  <div className="text_regular font-weight500 mb-1 line-height-normal">
                    Entity :
                  </div>
                  <div className="d-flex channel_wise justify-content-between align-items-center">
                    <div className="d-flex">
                      <div className="border-right border-color pr-15">
                        <div className="text_regular font-size12 line-height-normal">
                          Persons
                        </div>
                        <div className="font-weight500 font-size18 newsCard__textColor">
                          {el?.entitysentimentjson?.persons?.length}
                        </div>
                      </div>
                      <div className="border-right border-color pl-15 pr-15">
                        <div className="text_regular font-size12 line-height-normal">
                          Locations
                        </div>
                        <div className="font-weight500 font-size18 newsCard__textColor">
                          {el?.entitysentimentjson?.locations?.length}
                        </div>
                      </div>
                      <div className="pl-15">
                        <div className="text_regular font-size12 line-height-normal">
                          Organizations
                        </div>
                        <div className="font-weight500 font-size18 newsCard__textColor">
                          {el?.entitysentimentjson?.organizations?.length}
                        </div>
                      </div>
                    </div>
                    <Popover
                      overlayClassName={
                        authParams?.theme_type === "1"
                          ? "darkTheme"
                          : "lightTheme"
                      }
                      content={
                        el?.entitysentimentjson && (
                          <div
                            className="p-15 d-flex"
                            style={{ minWidth: "9rem" }}
                          >
                            {el?.entitysentimentjson?.persons?.length > 0 && (
                              <div
                                className={`${
                                  el?.entitysentimentjson?.locations?.length > 0
                                    ? "border-right border-color pr-15"
                                    : ""
                                }`}
                              >
                                <div className="text_regular font-weight500">
                                  Persons
                                </div>
                                {el?.entitysentimentjson?.persons.map(
                                  (el, i) => {
                                    return (
                                      <div className="text_regular font-size12">
                                        {el?.name}
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            )}
                            {el?.entitysentimentjson?.locations?.length > 0 && (
                              <div
                                className={`${
                                  el?.entitysentimentjson?.organizations
                                    ?.length > 0
                                    ? "border-right border-color pr-15"
                                    : ""
                                } pl-15`}
                              >
                                <div className="text_regular font-weight500">
                                  Locations
                                </div>
                                {el?.entitysentimentjson?.locations.map(
                                  (el, i) => {
                                    return (
                                      <div className="text_regular font-size12">
                                        {el?.name}
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            )}
                            {el?.entitysentimentjson?.organizations?.length >
                              0 && (
                              <div className="pl-15">
                                <div className="text_regular font-weight500">
                                  Organizations
                                </div>
                                {el?.entitysentimentjson?.organizations.map(
                                  (el, i) => {
                                    return (
                                      <div className="text_regular font-size12">
                                        {el?.name}
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            )}
                          </div>
                        )
                      }
                      title={null}
                      trigger="click"
                    >
                      {(el?.entitysentimentjson?.locations?.length > 0 ||
                        el?.entitysentimentjson?.organizations?.length > 0 ||
                        el?.entitysentimentjson?.persons?.length > 0) && (
                        <i className="fa fa-angle-down cursor-pointer" />
                      )}
                    </Popover>
                  </div>
                </div>

                <div
                  className="newsCard__statsCard border-radius-4 p-15 box-shadow mr-15"
                  style={{
                    minWidth: "20rem",
                  }}
                >
                  <div className="text_regular font-weight500 mb-1 line-height-normal">
                    Social Interaction
                  </div>
                  <div className="d-flex channel_wise justify-content-between align-items-center">
                    <div className="font-weight500 font-size18 newsCard__textColor">
                      {el?.social_interaction}
                    </div>
                    <Popover
                      overlayClassName={
                        authParams?.theme_type === "1"
                          ? "darkTheme"
                          : "lightTheme"
                      }
                      content={
                        !(el?.Socialengagement === "NA") && (
                          <div
                            className="p-15 custom_scroll1"
                            style={{ maxHeight: "20rem", overflow: "auto" }}
                          >
                            {el?.Socialengagement?.map((el, i) => {
                              return (
                                <div className="mb-15">
                                  <div className="mb-1 text_regular text-transform__capitalize font-weight500 mr-1 line-height-normal">
                                    <img
                                      src={
                                        SocialMedialogo?.[el?.channel]
                                          ? SocialMedialogo?.[el?.channel]
                                          : Default_Brand
                                      }
                                      alt={el?.channel}
                                      style={{ width: "1.5rem" }}
                                      className="channelIcon mr-1"
                                    />
                                    {el?.channel}
                                  </div>
                                  <div className="w-100 text_regular pl-15 font-size12">
                                    <div className="mb-1">
                                      Comments :{" "}
                                      <span className="blue-text">
                                        {el?.data?.comments}
                                      </span>
                                    </div>
                                    <div className="mb-1">
                                      Likes :{" "}
                                      <span className="blue-text">
                                        {el?.data?.likes}
                                      </span>
                                    </div>
                                    <div className="mb-1">
                                      Shares :{" "}
                                      <span className="blue-text">
                                        {el?.data?.shares}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )
                      }
                      title={null}
                      trigger="click"
                    >
                      {(el?.SharesCount?.channel_wise ||
                        el?.social_interaction > 0) && (
                        <i className="fa fa-angle-down cursor-pointer" />
                      )}
                    </Popover>
                  </div>
                </div>
              </div>
            </div>
          );
        })
      )}
      <PaginationComponent
        data={newsDatas.data}
        // filterPills={filterPills}
        PdfDownloadStatus={PdfDownloadStatus}
        PptGeneratingStatus={PptGeneratingStatus}
        totalPageNo={totalPageNo}
        metadata={metadata}
        section_index={section_index}
        widget_index={widget_index}
        isPreviewState={isPreviewState}
        // mentionPage={mentionPage}
        chart_type={chart_type}
        pagination={pagination}
        isDeepDiveDashboardView={isDeepDiveDashboardView}
      />
    </>
  );
};

export default NewsCard;
